export function getShopFilters(moduleType, moduleSubType,isSalePage) {
    
    const coupleArr = ['metal', 'sort', 'price', 'shipdate']
    const anniversaryArr = ['metal', 'style', 'carat', 'sort', 'shape', 'shipdate']
    const toiArr = ['metal', 'carat', 'sort', 'price', 'shape', 'shipdate']
    const presetArr = ['metal', 'style', 'shape', 'carat', 'sort', 'price', 'shape','estdate']
    const presetArrTwo = ['metal', 'shape', 'carat', 'sort', 'price', 'shape','estdate']

    const allArr = ['metal', 'style', 'sort', 'price', 'shape', 'shipdate']
    const bandArr = ['metal', 'style', 'sort', 'price', 'shape', 'shipdate']
    const restArr = ['metal', 'carat', 'sort', 'price', 'shape', 'shipdate']
    const instock = ['metal', 'sort', 'price', 'shape', 'shipdate']
    const openable_bangle = [...instock,'carat']
    const instock_ring = ['metal', 'sort', 'price', 'size', 'style', 'shape', 'shipdate']

    const merchant = ['metal', 'sort', 'price', 'style', 'shape', 'diamond_quality']


    const soiree_cocktail_jewelry = ['metal', 'sort', 'price', 'style', 'shipdate']
    const rose_portrait_jewelry = ['metal', 'sort', 'price', 'style', 'shipdate']
    const initial_necklace = ['metal', 'alphabets', 'price', 'shipdate', 'sort']
    
    const jewelry_sale = ['metal','style', 'shape', 'price', 'shipdate','sort','size']

    let fAttributes = [
        {
            name: 'metal',
            label: 'Metal',
            urlLabel: 'Metal',
            type: 'select',
            hasIcon: true,
            iconBasePath: '/assets/metals/',
            iconType: '.png',
            singleSelect: true,
            default: null,
            isOpen: false
        },
        {
            name:'diamond_quality',
            label:'Diamond Quality',
            urlLabel:'DiamondQuality',
            type:'select', 
            hasIcon:false,
            iconBasePath:'/assets/metals/',
            iconType:'.png',
            singleSelect:true,
            default:null,
            isOpen:false
        },
        {
            name: 'style',
            label: 'Style',
            urlLabel: 'Style',
            type: 'select',
            hasIcon: true,
            iconBasePath: '/assets/metals/',
            iconType: '.png',
            singleSelect: false,
            default: null,
            isOpen: false
        },
        {
            name: 'size',
            label: 'Size',
            urlLabel: 'Size',
            type: 'select',
            hasIcon: true,
            iconBasePath: '/assets/metals/',
            iconType: '.png',
            singleSelect: true,
            default: null,
            isOpen: false
        },
        {
            name: 'category',
            label: 'Category',
            urlLabel: 'Category',
            type: 'select',
            hasIcon: true,
            iconBasePath: '/assets/metals/',
            iconType: '.png',
            singleSelect: false,
            default: null,
            isOpen: false
        },
        {
            name: 'shape',
            label: 'Shape',
            urlLabel: 'Shape',
            type: 'select',
            hasIcon: true,
            iconBasePath: '/assets/metals/',
            iconType: '.png',
            singleSelect: true,
            default: null,
            isOpen: false
        },
        {
            name: 'carat',
            label: 'Carat',
            urlLabel: 'Carat',
            type: 'select',
            hasIcon: true,
            iconBasePath: '/assets/metals/',
            iconType: '.png',
            singleSelect: true,
            default: null,
            isOpen: false
        },
        {
            name: 'sort',
            label: 'Sort',
            urlLabel: 'Sort',
            type: 'select',
            displaySelected: true,
            hasIcon: false,
            iconBasePath: '',
            iconType: '.svg',
            singleSelect: true,
            isOpen: false,
            default: 'featured'
        },
        {
            name: 'shipdate',
            label: 'Shipdate',
            urlLabel: 'Shipdate',
            type: 'select',
            displaySelected: true,
            hasIcon: false,
            iconBasePath: '',
            iconType: '.svg',
            singleSelect: true,
            isOpen: false,
            default: ''
        },
        {
            name:'estdate',
            label:'Estdate',
            urlLabel:'Estdate',
            type:'select', 
            displaySelected:true, 
            hasIcon:false,
            iconBasePath:'',
            iconType:'.svg',
            singleSelect:true,
            isOpen:false,
            default:'anydate'
        },
        {
            name: 'alphabets',
            label: 'Alphabets',
            urlLabel: 'alphabets',
            type: 'select',
            displaySelected: true,
            hasIcon: false,
            iconBasePath: '',
            iconType: '.svg',
            singleSelect: true,
            isOpen: false,
            default: ''
        },
        {
            name: 'price',
            label: 'Price',
            urlLabel: 'Price',
            type: 'slider',
            displaySelected: true,
            singleSelect: true,
            default: null,
            isOpen: false,
            config: { step: 1, type: 'num', format: { notation: '$', position: 'prepend' } }
        }
    ]

   if( moduleSubType === 'couple-bands-ring' ){
            
        fAttributes = fAttributes.filter(attribute => coupleArr.includes(attribute.name));
    }

    

    if( moduleSubType === 'band-ring' ){

        fAttributes = fAttributes.filter(attribute => bandArr.includes(attribute.name));
        
    }

    if( moduleSubType === 'anniversary-ring' ){

        fAttributes = fAttributes.filter(attribute => anniversaryArr.includes(attribute.name));

    }
    
    if( moduleSubType === '' ){
        
        fAttributes = fAttributes.filter(attribute => allArr.includes(attribute.name));
        
    }
    
    if (isSalePage) {
        fAttributes = fAttributes.filter(attribute => jewelry_sale.includes(attribute.name));
    }
    
    if( ['full-eternity-ring','in-stock-earring', 'stud-earring', 'hoop-earring', 'tennis-bracelet', 'fashion-bracelet','fashion-earring','tennis-necklace','fashion-necklace', 'solitaire-necklace','hues-ring','soiree-ring','roses-potraits-ring'].includes(moduleSubType) ){
        fAttributes = fAttributes.filter(attribute => restArr.includes(attribute.name));
    }

    if( ['5000-engagement-rings', '10000-engagement-rings', '2000-engagement-rings', '3000-engagement-rings', 'all'].includes(moduleSubType) ){
        fAttributes = fAttributes.filter(attribute => merchant.includes(attribute.name));
        fAttributes.push({
            name:'carat',
            label:'Carat',
            urlLabel:'Carat',
            type:'slider', 
            displaySelected:true, 
            singleSelect:true,
            default:null,
            isOpen:false,
            config:{step:0.01, type: 'num', format:{notation:'ct', position:'append'}}
        });
    }

    if( moduleSubType === 'toi-et-moi-ring' ){
        fAttributes = fAttributes.filter(attribute => toiArr.includes(attribute.name));
    }

    if( moduleSubType === 'preset' ){

        fAttributes = fAttributes.filter(attribute => presetArr.includes(attribute.name));
    }
    if(['preset-pendant', 'preset-earrings'].includes(moduleSubType)){

        fAttributes = fAttributes.filter(attribute => presetArrTwo.includes(attribute.name));
    }

    if( moduleSubType === 'in-stock-pendant' ){

        fAttributes = fAttributes.filter(attribute => instock.includes(attribute.name));
    }

    if( moduleSubType === 'openable-bangle' ){

        fAttributes = fAttributes.filter(attribute => openable_bangle.includes(attribute.name));
    }

    if( ['in-stock-ring'].includes(moduleSubType) ){

        fAttributes = fAttributes.filter(attribute => instock_ring.includes(attribute.name));
        
    }
    
    if( moduleSubType === 'soiree-cocktail-jewelry' ){

        fAttributes = fAttributes.filter(attribute => soiree_cocktail_jewelry.includes(attribute.name));

    }
    if ( moduleSubType === 'rose_portrait_jewelry') {
        
        fAttributes = fAttributes.filter(attribute => rose_portrait_jewelry.includes(attribute.name));

    }

    if (moduleSubType === 'initial-necklace') {

        fAttributes = fAttributes.filter(attribute => initial_necklace.includes(attribute.name));

    }

   

    return fAttributes;
}